export default "<div class=\"container-fluid\">\n  <router-outlet></router-outlet>\n</div>\n";